export default class LinkItem {
    public id: string;
    public title: string;
    public description: string;
    public url: string;
    public urlTarget: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.description = "";
      this.url = "";
      this.urlTarget = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/linkItemEntity.ts